export default function authenticatedUserInfoReducer(state = {}) {
  return state;
}
